<script setup lang="ts">
import { useWallet, WalletMultiButton } from 'solana-wallets-vue';
import { watch } from 'vue';

const { ready, connect } = useWallet();

const connectWallet = () => {
  const button = document.getElementsByClassName('swv-button-trigger')[0] as
    | HTMLButtonElement
    | undefined;
  button?.click();
};

watch(ready, (r) => {
  if (r !== true) {
    return;
  }
  connect();
});
</script>

<template>
  <div>
    <v-btn
      @click="connectWallet"
      size="large"
      variant="elevated"
      color="background"
      >Connect Wallet
    </v-btn>
    <div class="hidden">
      <wallet-multi-button />
    </div>
  </div>
</template>
